module.exports = __webpack_public_path__ + "static/media/socialmedia-services-img2.5b6039ee.jpg";